import { MapTo } from '@adobe/aem-react-editable-components';
import AuthorizedUser, { AuthorizedUserEditConfig } from './AuthorizedUser';

export default MapTo('cob-corp-acquisition/components/creditonebank/authorized-user')(AuthorizedUser, AuthorizedUserEditConfig);